import { createSelector } from "@reduxjs/toolkit";

const getTrackingStore = (state) => state.tracking;

export const getMonitoraggio = createSelector(getTrackingStore, (tracking) =>
  Object.entries(tracking.monitoraggio.data).length > 0 ? tracking.monitoraggio.data : null
);

export const fetchMonitoraggioEnded = createSelector(getTrackingStore, (tracking) => tracking.monitoraggio.fetchEnded);

export const getEncounterUpdateNotification = createSelector(getTrackingStore, (tracking) => tracking.monitoraggio.updateNotification);

export const getOpenedNotification = createSelector(getTrackingStore, (tracking) => tracking.monitoraggio.openedNotification);
